// @ts-check
import { z } from 'zod';
import Timestamp from '@/store/modules/models/global/Timestamp';

export const contactSchema = z.object({
  id: z.number(),
  title: z.string(),
  email: z.string(),
  created_at: Timestamp,
  company_id: z.number(),
  envelopes_sent_count: z.number(),
});

export const listContactsSchema = contactSchema.pick({
  id: true,
  title: true,
  email: true,
}).array();

/** @typedef {z.infer<typeof contactSchema>} TContact */
/** @typedef {z.infer<typeof listContactsSchema>} TContacts */
